<template>
  <form-item-wrapper class="vform" :designer="designer" :field="field" :rules="rules" :design-state="designState"
    :parent-widget="parentWidget" :parent-list="parentList" :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex" :sub-form-col-index="subFormColIndex" :sub-form-row-id="subFormRowId">
    <el-checkbox-group ref="fieldEditor" v-model="fieldModel" v-show="!isReadMode" :disabled="field.options.disabled"
      :size="field.options.size" @change="handleChangeEvent">
      <template v-if="!!field.options.buttonStyle">
        <el-checkbox-button v-for="(item, index) in field.options.optionItems" :key="index" :label="item.value"
          :disabled="item.disabled" :border="field.options.border"
          :style="{ display: field.options.displayStyle, ...myStyles }">{{ item.label }}</el-checkbox-button>
      </template>
      <template v-else>
        <el-checkbox v-for="(item, index) in field.options.optionItems" :key="index" :label="item.value"
          :disabled="item.disabled" :border="field.options.border"
          :style="{ display: field.options.displayStyle, ...myStyles }">{{ item.label }}</el-checkbox>
      </template>
    </el-checkbox-group>
    <template v-if="isReadMode">
      <span class="readonly-mode-field">{{ optionLabel }}</span>
    </template>
  </form-item-wrapper>
</template>

<script>
import FormItemWrapper from './form-item-wrapper'
import emitter from '@/utils/emitter'
import i18n, { translate } from "@/utils/i18n";
import fieldMixin from "@/components/form-designer/form-widget/field-widget/fieldMixin";

export default {
  name: "checkbox-widget",
  componentName: 'FieldWidget',  //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,

    designState: {
      type: Boolean,
      default: false
    },

    subFormRowIndex: { /* 子表单组件行索引，从0开始计数 */
      type: Number,
      default: -1
    },
    subFormColIndex: { /* 子表单组件列索引，从0开始计数 */
      type: Number,
      default: -1
    },
    subFormRowId: { /* 子表单组件行Id，唯一id且不可变 */
      type: String,
      default: ''
    },

  },
  components: {
    FormItemWrapper,
  },
  inject: ['refList', 'globalOptionData', 'globalModel'],
  data() {
    return {
      oldFieldValue: null, //field组件change之前的值
      fieldModel: null,
      rules: [],
    }
  },
  computed: {
    myStyles() {
      return {
        'font-size': this.getFormConfig().fontSize + '!important',
        'font-weight': this.getFormConfig().fontWeight + '!important'
      }
    },
  },
  beforeCreate() {
    /* 这里不能访问方法和属性！！ */
  },

  created() {
    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
       需要在父组件created中初始化！！ */
    if (typeof this.field.options.defaultValue === 'string') {
      this.field.options.defaultValue = this.field.options.defaultValue.split(',').map(e => e)
    }else{
      this.field.options.defaultValue = this.field.options.defaultValue.map(e => e)
    }
    this.registerToRefList()
    this.initOptionItems()
    this.initFieldModel()
    this.initEventHandler()
    this.buildFieldRules()

    this.handleOnCreated()
  },

  mounted() {
    this.handleOnMounted()
  },

  beforeDestroy() {
    this.unregisterFromRefList()
  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/global.scss"; //* form-item-wrapper已引入，还需要重复引入吗？ *//

// .vform ::v-deep .el-checkbox__label {
//   font-size: unset;
// }
</style>
